import { makeAutoObservable } from "mobx"

class CalculatorStore {
  searchParams = ""
  currentChar = ""
  currentCharNew = ""
  numToWords = ""
  manageStateForSlider = ''
  screenNo = "Scr1"
  customRange1Text = "Age"
  bgSize = ''
  valsNew = 0
  rangeInput = 43
  minValue = 18
  maxValue = 75
  ageValue = 43
  retireAgeValue = 60
  yourGraphValue = 60
  calcwidth = 0
  chartOptions = ''
  fifthScreenFlag = false
  showData = 0
  errorMessage = ""
  errorAge = false
  calc_pagescrn = "first"
  multipleAmt = 0
  mainFlag = true
  ShowPlans = false
  retireCalcFlag = false
  totalAmtAtRetire = 0
  expensesAmtAtRetire = 0
  uniqueInflationRates = 0
  savingsAmtAtRetire = 0
  additionalSavingsAmtAtRetire = 0
  firstYearAdditionalSavingsAmtAtRetire = 0
  ageTillRetirement = 0
  ageRetireCalc = true
  surviveTillAge = 0
  CashFlowValue = []
  additionalAmtAtRetire = 0
  isDisabled = false
  errorAmountMessage = ""
  errorAmount = false
  incomeProp = true
  scr34ScreenFlag = 0
  currentExpensesValue1 = 0
  currentExpensesValue2 = 0
  currentExpensesValue3 = 0
  accurateResultValue = 0
  accurateResultValueHouse = 0
  accurateResultValueFood = 0
  accurateResultValueTransport = 0
  accurateResultValueEntertainment = 0
  accurateResultValueMiscellaneous = 0

  constructor() { makeAutoObservable(this) }

  setSearchParams = (data) => (this.searchParams = data)
  setCurrentChar = (data) => (this.currentChar = data)
  setCurrentCharNew = (data) => (this.currentCharNew = data)
  setNumToWords = (data) => (this.numToWords = data)
  setManageStateForSlider = (data) => (this.manageStateForSlider = data)
  setscreenNo = (data) => (this.screenNo = data)
  setCustomRange1Text = (data) => (this.customRange1Text = data)
  setbgSize = (data) => (this.bgSize = data)
  setValsNew = (data) => (this.valsNew = data)
  setRangeInput = (data) => (this.rangeInput = data)
  setminValue = (data) => (this.minValue = data)
  setmaxValue = (data) => (this.maxValue = data)
  setAgeValue = (data) => (this.ageValue = data)
  setRetireAgeValue = (data) => (this.retireAgeValue = data)
  setYourGraphValue = (data) => (this.yourGraphValue = data)
  setCalcwidth = (data) => (this.calcwidth = data)
  setChartOptions = (data) => (this.chartOptions = data)
  setFifthScreenFlag = (data) => (this.fifthScreenFlag = data)
  setAgeRetireCalc = (data) => (this.ageRetireCalc = data)
  setShowData = (data) => (this.showData = data)
  setErrorMessage = (data) => (this.errorMessage = data)
  setErrorAge = (data) => (this.errorAge = data)
  setCalcPageScrn = (data) => (this.calc_pagescrn = data)
  setMultipleAmt = (data) => (this.multipleAmt = data)
  setMainFlag = (data) => (this.mainFlag = data)
  setShowPlans = (data) => (this.ShowPlans = data)

  setRetireCalcFlag = (data) => (this.retireCalcFlag = data)  
  setTotalAmtAtRetire = (data) => (this.totalAmtAtRetire = data)  
  setExpensesAmtAtRetire = (data) => (this.expensesAmtAtRetire = data)
  setUniqueInflationRates = (data) => (this.uniqueInflationRates = data)
  setSavingsAmtAtRetire = (data) => (this.savingsAmtAtRetire = data)
  setAdditionalSavingsAmtAtRetire = (data) => (this.additionalSavingsAmtAtRetire = data)
  setFirstYearAdditionalSavingsAmtAtRetire = (data) => (this.firstYearAdditionalSavingsAmtAtRetire = data)
  setAgeTillRetirement = (data) => (this.ageTillRetirement = data)  
  setSurviveTillAge = (data) => (this.surviveTillAge = data)  
  setCashFlowValue = (data) => (this.CashFlowValue = data) 
  setAdditionalAmtAtRetire = (data) => (this.additionalAmtAtRetire = data) 

  setIsDisabled = (data) => ((this.isDisabled) = data)  
  setErrorAmountMessage = (data) => ((this.errorAmountMessage) = data)  
  setErrorAmount = (data) => ((this.errorAmount) = data)  
  setIncomeProp = (data) => ((this.incomeProp) = data)  
  setScr34ScreenFlag = (data) => ((this.scr34ScreenFlag) = data)  

  setcurrentExpensesValue1 = (data) => ((this.currentExpensesValue1) = data)  
  setcurrentExpensesValue2 = (data) => ((this.currentExpensesValue2) = data)  
  setcurrentExpensesValue3 = (data) => ((this.currentExpensesValue3) = data)  

  setAccurateResultValue = (data) => ((this.accurateResultValue) = data)  
  setAccurateResultValueHouse = (data) => ((this.accurateResultValueHouse) = data)  
  setAccurateResultValueFood = (data) => ((this.accurateResultValueFood) = data)  
  setAccurateResultValueTransport = (data) => ((this.accurateResultValueTransport) = data)  
  setAccurateResultValueEntertainment = (data) => ((this.accurateResultValueEntertainment) = data)  
  setAccurateResultValueMiscellaneous = (data) => ((this.accurateResultValueMiscellaneous) = data)  

}

export default new CalculatorStore()
